module.exports = __webpack_public_path__ + "static/media/winterfest.6708802f.jpg";